import { Helmet } from 'react-helmet-async';

import storeScriptsConfig from './store-scripts.json';

type StoreScriptsProps = {
  storeId: number | string;
};

export const StoreScripts = ({ storeId }: StoreScriptsProps) => {
  const storeScripts = storeScriptsConfig[storeId];

  const scriptType = 'text/javascript';

  if (!storeScripts) return null;

  const srcScripts = storeScripts
    .filter(({ type }: { type: string }) => type === 'src')
    .map(({ content }: { content: string }) => ({
      type: scriptType,
      src: content,
    }));

  const contentScripts = storeScripts
    .filter(({ type }: { type: string }) => type !== 'src')
    .map(({ content }: { content: string }) => ({
      type: scriptType,
      innerHTML: content,
    }));

  return <Helmet script={[...srcScripts, ...contentScripts]} />;
};
